import { useLanguage, t } from "../../../../i18n";
import React from "react";
import { HiOutlineMapPin } from "react-icons/hi2";
import "./LocationBadge.css";
export default function LocationBadge({
  city
}) {
  useLanguage();
  return <div className="bb-location-badge">
      <span className="bb-location-badge__icon">
        <HiOutlineMapPin />
      </span>
      <span className="bb-location-badge__text">{t(city)}</span>
    </div>;
}
